import React, { useContext } from 'react';
import styled from 'styled-components';
import { ReactComponent as SensitiveInfoIcon } from '@ubeya/shared-web/assets/sensitive-info.svg';
import { Label as FieldLabel, Tooltip } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const TooltipTriggerArea = styled.div`
  width: 100%;
`;

const StyledLabel = styled(FieldLabel)`
  .label {
    color: ${({ theme }) => theme.colors.black};
  }
`;

const MaskedValueShell = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.grey1};
  border-radius: 2px;
  width: 100%;
  padding: 10px;
  min-height: 46px;
  outline: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.grey1};
  color: ${({ theme }) => theme.colors.grey3};
  cursor: default;
  user-select: none;

  &:hover,
  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.grey1};
  }
`;

const IconWrap = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  line-height: 0;
`;

const StyledInfoIcon = styled(SensitiveInfoIcon)`
  g path:nth-of-type(1) {
    fill: ${({ theme }) => theme.colors.grey3};
  }
  g path:nth-of-type(2) {
    stroke: ${({ theme }) => theme.colors.grey3};
  }
`;

const SensitiveFieldProfileMask = ({ label }) => {
  const { t } = useContext(ConfigContext);
  const hint = t('sensitiveDataValueHidden');

  return (
    <Tooltip body={hint} placement="top">
      <TooltipTriggerArea aria-label={hint}>
        <StyledLabel title={label}>
          <MaskedValueShell tabIndex={-1}>
            <IconWrap aria-hidden>
              <StyledInfoIcon width={18} height={18} />
            </IconWrap>
          </MaskedValueShell>
        </StyledLabel>
      </TooltipTriggerArea>
    </Tooltip>
  );
};

export default SensitiveFieldProfileMask;
